import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Flowbite } from 'flowbite-react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import UserDetail from './pages/UserDetail';
import './App.css';

function App() {
  const isAuthenticated = !!localStorage.getItem('adminToken');

  return (
    <Flowbite>
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
        <BrowserRouter>
          <Routes>
            {/* Public route */}
            <Route 
              path="/login" 
              element={
                isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />
              } 
            />

            {/* Protected routes */}
            <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
              <Route 
                index 
                element={<Navigate to="/dashboard" replace />} 
              />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="users" element={<Users />} />
              <Route path="users/:userId" element={<UserDetail />} />
              
              {/* Catch all route for undefined paths */}
              <Route 
                path="*" 
                element={<Navigate to="/dashboard" replace />} 
              />
            </Route>
          </Routes>
        </BrowserRouter>
        
        {/* Add ToastContainer */}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </div>
    </Flowbite>
  );
}

export default App;
